import { Grid, Typography } from '@mui/material'
import BottomDrawer from 'components/BottomDrawer'

function InvestmentDetailModal({ open, onClose, investmentDetails }) {
  return (
    <BottomDrawer title="Investment Dates" open={open} onClose={onClose}>

      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography color="text.main" fontWeight={500} variant="h6">
            Date/Time Start Customer: {" "}
            <Typography
              component="span"
              color="text.secondary"
              fontWeight={400}
              variant="subtitle1"
            >
              <b>
                {investmentDetails?.dateStartCustomer}
              </b>{" "}
              {investmentDetails?.timeStartCustomer}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography color="text.main" fontWeight={500} variant="h6">
            Date/Time Start Admin: {" "}
            <Typography
              component="span"
              color="text.secondary"
              fontWeight={400}
              variant="subtitle1"
            >
              <b>
                {investmentDetails?.dateStartAdmin}
              </b>{" "}
              {investmentDetails?.timeStartAdmin}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography color="text.main" fontWeight={500} variant="h6">
            Date/Time Start Investment: {" "}
            <Typography
              component="span"
              color="text.secondary"
              fontWeight={400}
              variant="subtitle1"
            >
              <b>
                {investmentDetails?.dateStartInvestment}
              </b>{" "}
              {investmentDetails?.timeStartInvestment}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={12} mt={2}>
          <Typography color="text.main" fontWeight={500} variant="h6">
            Date/Time End Customer: {" "}
            <Typography
              component="span"
              color="text.secondary"
              fontWeight={400}
              variant="subtitle1"
            >
              <b>
                {investmentDetails?.dateEndCustomer}
              </b>{" "}
              {investmentDetails?.timeEndCustomer}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography color="text.main" fontWeight={500} variant="h6">
            Date/Time End Admin: {" "}
            <Typography
              component="span"
              color="text.secondary"
              fontWeight={400}
              variant="subtitle1"
            >
              <b>
                {investmentDetails?.dateEndAdmin}
              </b>{" "}
              {investmentDetails?.timeEndAdmin}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography color="text.main" fontWeight={500} variant="h6">
            Date/Time End Admin: {" "}
            <Typography
              component="span"
              color="text.secondary"
              fontWeight={400}
              variant="subtitle1"
            >
              <b>
                {investmentDetails?.dateEndInvestment}
              </b>{" "}
              {investmentDetails?.timeEndInvestment}
            </Typography>
          </Typography>
        </Grid>
      </Grid>
    </BottomDrawer>
  )
}

export default InvestmentDetailModal